import { createSelector } from "reselect";

export const configCiTestCasesStatusesSelector = createSelector(
    state => state.services.configCiTestCasesStatuses,
    state => state
);
